import { IPwaPreviewConfig } from '@adminPortal/_common/_interfaces/IPwaPreviewConfig';
import { InjectionToken } from '@angular/core';
import { IPwaConfig } from '@sharedLib/models/interfaces/IPwaConfig';

export const PWA_CONFIG = new InjectionToken<IPwaConfig>('app.config');
export const NEW_PWA_CONFIG = new InjectionToken<IPwaPreviewConfig>('app.config');
